import { render } from "./SimpleAppointmentsTable.vue?vue&type=template&id=0336474b"
import script from "./SimpleAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./SimpleAppointmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QCheckbox,QTooltip,QTd});
